export const translations = {
  hr: {
    // Header
    home: "Početna",
    shop: "Trgovina",
    blog: "Blog",
    contact: "Kontakt",
    admin: "Admin",
    login: "Prijava",
    logout: "Odjava",
    language: "Jezik",
    croatian: "Hrvatski",
    english: "Engleski",

    // Hero Sections
    heroTitle:
      "Putovanje kroz vrijeme – Od zore civilizacije do današnjeg svijeta",
    heroDescription:
      "Istražite epske bitke, legendarne dvorce, drevna carstva i modernu povijest – sve na jednom mjestu",
    exploreHistory: "Istražite povijest",
    blogHeroTitle: "Povijesne kronike",
    blogHeroSubtitle: "Istražite prošlost kroz fascinantne priče i uvide",
    shopHeroTitle: "Kupujte povijesne replike i makete",
    shopHeroSubtitle:
      "Brza isporuka, sigurna naplata i pažljivo odabrani proizvodi za kolekcionare, hobiste i ljubitelje povijesti.",
    webshopHeroBadge: "Povijesni webshop",
    webshopHeroTitle: "Pronađite repliku koju ćete s ponosom pokazati",
    webshopHeroSubtitle:
      "Pregledajte najtraženije proizvode, usporedite cijene i naručite u par klikova.",
    shopNow: "Kupi odmah",
    browseStories: "Trebate pomoć pri odabiru?",
    shopByCollection: "Kupuj po kolekcijama",
    heroFastProcessing: "Obrada narudžbe unutar 24h",
    heroCashOnDeliveryCroatia: "Dostava u Hrvatsku i inozemstvo",
    heroSecureCardCheckout: "Sigurna Stripe naplata",
    trustSupportEmail: "Podrška putem emaila",

    // Home Page
    latestStories: "Najnovije priče",
    latestFromWebshop: "Najprodavanije i novo u ponudi",
    officialDealerships: "Službena zastupništva",
    exploreCategories: "Istražite povijesne kategorije",
    viewAllProducts: "Pogledaj ponudu",
    viewAllStories: "Pogledajte sve priče",
    continueShopping: "Nastavi kupnju",
    addToCart: "Dodaj u košaricu odmah",
    viewDetails: "Pogledaj detalje",
    readMore: "Pročitaj više",

    // Categories
    artifacts: "Artefakti",
    books: "Knjige",
    replicas: "Replike",
    collectibles: "Kolekcionarski predmeti",
    warMachines: "Ratni strojevi",
    castles: "Dvorci",
    myths: "Mitovi",
    battles: "Bitke",
    onTodaysDay: "Na današnji dan",
    stories: "priče",
    history: "Povijest",
    education: "Obrazovanje",
    replicasLabel: "Replike",
    models: "Makete",
    modelAccessories: "Dodaci za makete",
    historicalCoins: "Povijesni novac",
    weapons: "Oružje",
    militaryEquipment: "Ratna oprema",
    collections: "Kolekcije",
    colorDefault: "Zadana",
    colorOlive: "Maslinasta",
    colorSand: "Pješčana",
    colorBlack: "Crna",
    colorWhite: "Bijela",
    colorGray: "Siva",
    colorRed: "Crvena",
    colorBlue: "Plava",
    colorGreen: "Zelena",
    colorBrown: "Smeđa",
    modelAccessoriesNotification:
      "U proizvode maketa nije uključen pribor za sastavljanje i uređivanje. Otiđite na Dodaci za makete da bi ste pronašli pribor.",

    // Shop
    shoppingCart: "Košarica",
    products: "Proizvodi",
    orderSummary: "Sažetak narudžbe",
    subtotal: "Međuzbroj",
    shipping: "Dostava",
    total: "Ukupno",
    freeShipping: "BESPLATNA DOSTAVA",
    addMoreForFreeShipping: "Dodajte €{amount} više za BESPLATNU dostavu!",
    proceedToPayment: "Nastavi na sigurnu naplatu",
    backToShop: "Natrag u trgovinu",
    yourCartIsEmpty: "Vaša košarica je prazna",
    addProductsBeforeCheckout:
      "Dodajte proizvode u košaricu i završite narudžbu za manje od 2 minute.",
    goToWebshopButton: "Pogledaj proizvode",
    checkout: "Naplata",
    enterStreetAddress: "Unesite svoju ulicu i kućni broj",
    enterHouseApartmentNumber: "Kućni/Apartmanski broj",
    zipCodeExample: "npr., 21000 (samo brojevi)",
    emailExample: "npr., vas.email@primjer.com",
    phoneNumberExample: "npr., +385123456789 (mora početi s +)",

    // Checkout
    shippingInformation: "Informacije o dostavi",
    firstName: "Ime",
    lastName: "Prezime",
    address: "Adresa",
    houseNumber: "Kućni broj",
    city: "Grad",
    zipCode: "Poštanski broj",
    country: "Država",
    email: "Email",
    instagram: "Instagram",
    phone: "Telefon",
    phoneNumber: "Broj telefona",
    enterFirstName: "Unesite vaše ime",
    enterLastName: "Unesite vaše prezime",
    enterAddress: "Unesite vašu adresu",
    enterHouseNumber: "Kućni/broj stana",
    enterZipCode: "npr. 21000 (samo brojevi)",
    enterCountry: "Unesite vašu državu",
    enterEmail: "npr. vaš.email@primjer.com",
    enterPhone: "npr. +385123456789 (mora početi s +)",
    phoneMustStartWithPlus:
      "Broj telefona mora početi s + (npr. +385123456789)",
    phoneTooShort: "Broj telefona je prekratak",
    zipCodeNumbersOnly: "Poštanski broj mora sadržavati samo brojeve",

    // Product Detail Page
    noImageAvailable: "Nema dostupne slike",
    added: "Dodano",
    available: "Dostupno",
    outOfStock: "Nema na stanju",
    howToPurchase: "Kako kupiti",
    toBuyThisProduct: "Da biste kupili ovaj proizvod",
    goToWebshop: "Idite na našu",
    webshop: "Webshop",
    page: "stranicu",
    findProductAndClick:
      'Pronađite ovaj proizvod i kliknite "Dodaj u košaricu"',
    continueShoppingOrCheckout:
      "Dodajte još proizvoda ili nastavite na sigurnu naplatu",
    fillDetailsAndComplete:
      "Unesite podatke za dostavu i dovršite kupnju bez rizika",
    addToWishlist: "Dodaj u listu želja",
    share: "Podijeli",
    relatedProducts: "Povezani proizvodi",
    moreHistoricalItems: "Više povijesnih predmeta",
    discoverMoreArtifacts:
      "Otkrijte više fascinantnih povijesnih artefakata...",
    viewMore: "Pogledaj više",
    backToAllProducts: "Natrag na sve proizvode",

    // Admin
    addProduct: "Dodaj proizvod",
    adminPanel: "Admin Panel",
    adminPanelSubtitle: "Upravljajte svojim povijesnim sadržajem i proizvodima",
    adminDashboard: "Nadzorna ploča",
    adminBlogs: "Blogovi",
    adminProducts: "Proizvodi",
    adminDiscountCodes: "Kodovi popusta",
    adminOrders: "Narudžbe",
    adminCategories: "Kategorije",
    adminProductTags: "Tagovi proizvoda",
    adminShippingRates: "Dostava",
    adminDealerships: "Zastupništva",
    welcomeAdmin: "Dobrodošli",
    addBlog: "Dodaj blog",
    editBlog: "Uredi blog",
    blogTitle: "Naslov bloga",
    blogContent: "Sadržaj bloga",
    blogExcerpt: "Uvod bloga",
    blogCategory: "Kategorija bloga",
    blogImage: "Slika bloga",
    editProduct: "Uredi proizvod",
    productName: "Naziv proizvoda",
    productDescription: "Opis proizvoda",
    productPrice: "Cijena proizvoda",
    productCategory: "Kategorija proizvoda",
    productStock: "Stanje",
    save: "Spremi",
    cancel: "Odustani",
    loading: "Učitavanje...",
    noDescription: "Opis nije dostupan",

    // Blog
    latestBlogs: "Najnoviji blogovi",
    blogNotFound: "Blog nije pronađen",
    blogNotFoundMessage: "Blog koji tražite ne postoji.",
    backToBlog: "Natrag na Blog",
    backToAllBlogs: "Natrag na sve Blogove",
    relatedArticles: "Povezani članci",
    moreHistoricalStories: "Više povijesnih priča",
    discoverMoreTales: "Otkrijte više fascinantnih priča iz povijesti...",
    author: "Autor",
    published: "Objavljeno",
    unpublished: "Neobjavljeno",

    // Contact
    contactUs: "Kontaktirajte nas",
    sendMessage: "Pošaljite poruku",
    yourName: "Vaše ime",
    yourEmail: "Vaš email",
    message: "Poruka",
    send: "Pošalji",
    getInTouch: "Javite nam se prije kupnje",
    haveQuestions:
      "Trebate preporuku proizvoda ili pomoć oko narudžbe? Odgovaramo brzo.",
    contactInformation: "Kontakt informacije",
    businessAddress: "Poslovna adresa",
    businessDetails: "Poslovni podaci",
    djelatnost:
      "Djelatnost: 47920, Uslužne djelatnosti posredovanja u specijaliziranoj trgovini na malo",
    oib: "OIB: MB-99075784",
    yearOfEstablishment: "Godina osnivanja: 2025",
    businessDocuments: "Poslovni dokumenti",
    termsOfBusiness: "Opći uvjeti poslovanja",
    privacyPolicy: "Politika privatnosti",
    rightToTerminate: "Pravo na jednostrani raskid ugovora",
    legalTermsTitle: "Opći uvjeti poslovanja",
    legalTermsSubtitle: "Opći uvjeti poslovanja web trgovine HISTORIO",
    legalTermsTrade: "Obrt za posredovanje u trgovini",
    legalTermsOwner: "Vlasnik: Mirko Vuletić",
    legalTermsAddress: "Adresa: Mosećka 107, 21000 Split",
    legalTermsOib: "OIB: 99075784",
    legalTermsContactLabel: "Kontakt:",
    legalTermsPhone: "+385976991203",
    legalTermsGeneralTitle: "Opće odredbe",
    legalTermsGeneralBody:
      "Ovim se Općim uvjetima poslovanja uređuje poslovanje web trgovine HISTORIO dostupne na historio.hr. Korisnik je svaka osoba koja pristupi stranici i izvrši narudžbu. Kupoprodajni ugovor smatra se sklopljenim kada Kupac naruči proizvod putem web stranice, a Prodavatelj potvrdi narudžbu.",
    legalTermsPricingTitle: "Cijene i plaćanje",
    legalTermsPricingBody:
      "Sve cijene izražene su u eurima (EUR). Trgovac nije u sustavu PDV-a prema čl. 90. st. 2 Zakona o PDV-u. Plaćanje se vrši putem Stripe sustava kartičnog plaćanja.",
    legalTermsShippingTitle: "Dostava",
    legalTermsShippingBody:
      "Proizvodi se dostavljaju na području Republike Hrvatske i inozemstva putem ugovorene dostavne službe. Rok isporuke je 3-7 radnih dana unutar Hrvatske, ovisno o dostupnosti proizvoda.",
    legalTermsWithdrawalTitle: "Pravo na jednostrani raskid",
    legalTermsWithdrawalBody:
      "Kupac ima pravo, bez navođenja razloga, raskinuti ugovor u roku od 14 dana od primitka robe. Više o postupku nalazi se na stranici Pravo na jednostrani raskid ugovora.",
    legalTermsComplaintsTitle: "Reklamacije i povrat",
    legalTermsComplaintsBody:
      "Ako Kupac primi oštećen proizvod ili proizvod koji ne odgovara narudžbi, dužan je obavijestiti Prodavatelja u roku od 14 dana. Prodavatelj je obvezan u razumnom roku zamijeniti proizvod ili izvršiti povrat novca.",
    legalTermsDisputesTitle: "Rješavanje sporova",
    legalTermsDisputesBody:
      "Sporove nastale između Kupca i Prodavatelja moguće je riješiti izvansudskim putem putem platforme Europske komisije za online rješavanje sporova. Za sve sporove nadležan je stvarno nadležni sud u Splitu.",
    legalPrivacyTitle: "Politika privatnosti",
    legalPrivacyIntro:
      "Obrt HISTORIO poštuje privatnost svojih korisnika i obvezuje se čuvati osobne podatke.",
    legalPrivacyCollectedTitle: "Koje podatke prikupljamo?",
    legalPrivacyCollected1: "Ime i prezime",
    legalPrivacyCollected2: "Adresu za dostavu",
    legalPrivacyCollected3: "E-mail adresu i broj telefona",
    legalPrivacyCollected4:
      "Podatke o plaćanju (putem Stripe-a, trgovac ne vidi pune podatke o kartici)",
    legalPrivacyPurposeTitle: "Svrha obrade podataka",
    legalPrivacyPurposeIntro: "Podaci se koriste isključivo radi:",
    legalPrivacyPurpose1: "obrade narudžbi i dostave proizvoda",
    legalPrivacyPurpose2: "komunikacije s kupcem",
    legalPrivacyPurpose3:
      "ispunjavanja zakonskih obveza (računi i knjigovodstvo)",
    legalPrivacyGdprTitle: "GDPR i pravna osnova obrade",
    legalPrivacyGdprBody:
      "Osobne podatke obrađujemo u skladu s Općom uredbom o zaštiti podataka (GDPR). Pravna osnova obrade može biti izvršenje ugovora, poštivanje zakonskih obveza, legitimni interes ili privola korisnika, ovisno o svrsi obrade.",
    legalPrivacyControllerTitle: "Voditelj obrade",
    legalPrivacyControllerBody:
      "Voditelj obrade osobnih podataka je HISTORIO. Za sva pitanja vezana uz zaštitu podataka možete nas kontaktirati na:",
    legalPrivacyRetentionTitle: "Rok čuvanja podataka",
    legalPrivacyRetentionBody:
      "Podatke čuvamo onoliko dugo koliko je potrebno za ispunjenje svrhe obrade i zakonskih obveza, nakon čega ih brišemo ili anonimiziramo.",
    legalPrivacyRightsTitle: "Prava korisnika",
    legalPrivacyRightsBody:
      "Korisnici imaju pravo na pristup, ispravak, brisanje i ograničavanje obrade svojih podataka u skladu s GDPR uredbom. Zahtjev se podnosi na e-mail:",
    legalPrivacyCookiesTitle: "Kolačići (Cookies)",
    legalPrivacyCookiesBody:
      "Web stranica koristi kolačiće radi boljeg korisničkog iskustva i analitike. Korisnici mogu odbiti kolačiće u postavkama preglednika.",
    legalPrivacySharingTitle: "Prosljeđivanje podataka",
    legalPrivacySharingBody:
      "Podaci se prosljeđuju samo nužnim partnerima: dostavnoj službi i Stripe sustavu za plaćanje.",
    legalWithdrawalTitle: "Pravo na jednostrani raskid ugovora",
    legalWithdrawalP1:
      "Kupac može, bez navođenja razloga, raskinuti ugovor sklopljen na daljinu u roku od 14 dana od dana preuzimanja proizvoda.",
    legalWithdrawalP2:
      "Da bi ostvario pravo na jednostrani raskid, Kupac mora poslati obavijest o raskidu na e-mail:",
    legalWithdrawalP3:
      "Kupac snosi izravne troškove povrata robe. Roba mora biti vraćena u ispravnom i nekorištenom stanju.",
    legalWithdrawalP4:
      "Prodavatelj je dužan izvršiti povrat uplaćenog iznosa u roku od 14 dana od primitka obavijesti o raskidu, odnosno nakon što zaprimi vraćeni proizvod.",
    legalWithdrawalFormTitle: "Obrazac za jednostrani raskid (PDF)",
    legalWithdrawalFormText: "Obrazac za raskid dostupan je kao PDF dokument:",
    legalWithdrawalFormCta: "Preuzmi obrazac (PDF)",
    sendUsMessage: "Pošaljite upit našem timu",
    subject: "Predmet",
    whatIsThisAbout: "Kako vam možemo pomoći?",
    tellUsMore: "Napišite što tražite i poslat ćemo preporuku.",
    sendMessageButton: "Pošalji upit",
    afterSubmittingNotePrefix:
      "* Poruka će biti poslana direktno našem timu putem kontakt forme. Za hitne upite možete nas kontaktirati i na",
    afterSubmittingNoteSuffix: ".",
    frequentlyAskedQuestions: "Često postavljena pitanja",
    howToPurchaseCollectibles:
      "Kako mogu kupiti kolekcionarske predmete na Historiju?",
    howToPurchaseAnswer:
      "Odaberite proizvod, dodajte ga u košaricu i završite kupnju kroz sigurnu naplatu u nekoliko koraka.",
    canIContributeArticles: "Mogu li doprinijeti člancima na Historio blogu?",
    canIContributeAnswer:
      "Da, dobrodošli su nam gostujući pisci! Javite nam se putem kontakt forme za detalje o slanju.",
    areReplicasHandmade: "Jesu li replike na Historiju ručno rađene?",
    areReplicasHandmadeAnswer:
      "Da, mnogi od naših predmeta su ručno rađeni od strane vještih obrtnika.",
    doesHistorioShipInternationally: "Dostavlja li Historio međunarodno?",
    doesHistorioShipInternationallyAnswer:
      "Da. Dostavljamo u Hrvatsku i inozemstvo, a cijenu i rok isporuke vidite prije potvrde narudžbe.",
    canIPayWithCashOnDelivery: "Mogu li platiti pouzećem?",
    canIPayWithCashOnDeliveryAnswerPrefix:
      "Da! Ako želite platiti pouzećem, molimo vas da nas kontaktirate putem kontakt forme ili na email",
    canIPayWithCashOnDeliveryAnswerSuffix:
      "s detaljima vaše narudžbe. Plaćanje se vrši gotovinom prilikom dostave i dostupno je za narudžbe unutar Hrvatske.",

    // Payment Methods
    creditCard: "Kreditna/Debitna kartica",
    creditDebitCard: "Kreditna/Debitna kartica (Stripe)",
    cashOnDelivery: "Pouzećem",
    availableWorldwide: "Dostupno širom svijeta",
    placeOrderCashOnDelivery: "Naručite (Pouzećem)",
    placeOrder: "Potvrdi narudžbu",

    // Discount Code
    discountCode: "Kod za popust",
    enterCode: "Unesite kod",
    apply: "Primijeni",
    discount: "Popust",
    discountApplied: "Popust primijenjen",
    enterDiscountCode: "Molimo unesite kod za popust",
    invalidDiscountCode: "Neispravan kod za popust",

    // Cart
    cartIsEmpty: "Vaša košarica je prazna",
    addItemsToCart: "Dodajte artikle u košaricu za checkout",
    free: "Besplatno",

    // Errors
    checkoutError: "Došlo je do greške. Molimo pokušajte ponovno.",

    // Product Detail Page Additional
    productNotFound: "Proizvod nije pronađen",
    productNotFoundMessage: "Proizvod koji tražite ne postoji.",

    // Contact Page Additional
    thankYouForMessage:
      "Hvala vam na poruci! Uspješno smo zaprimili vaš upit i javit ćemo vam se uskoro.",
    errorTryAgain:
      "Došlo je do greške. Pokušajte ponovno ili nam pošaljite email direktno na historio.info@gmail.com",
    sending: "Slanje...",

    // Success
    orderSuccessful: "Narudžba uspješna!",
    thankYouForOrder: "Hvala vam na narudžbi!",
    confirmationEmail: "Potvrda će biti poslana na vaš email.",
    orderPlacedSuccessfully: "Narudžba uspješno zaprimljena!",
    paymentSuccessful: "Plaćanje uspješno!",
    thankYouOrderConfirmedProcessedSoon:
      "Hvala na narudžbi. Vaša narudžba je potvrđena i uskoro će biti obrađena.",
    thankYouPurchaseConfirmed: "Hvala na kupnji. Vaša narudžba je potvrđena.",
    whatHappensNext: "Što slijedi?",
    youWillReceiveEmailConfirmationShortly: "Uskoro ćete primiti email potvrdu",
    orderProcessedWithinBusinessDays:
      "Vaša narudžba će biti obrađena unutar 1-2 radna dana",
    cashOnDeliveryPaymentInfo:
      "Platiti ćete gotovinom kada paket bude dostavljen na vašu adresu",
    youWillReceiveTrackingInfoWhenShipped:
      "Dobit ćete informacije za praćenje pošiljke nakon slanja",
    cashOnDeliveryInformation: "Informacije o plaćanju pouzećem",
    cashOnDeliveryExactAmountNote:
      "Molimo pripremite točan iznos kada dostavljač stigne. Ukupan iznos bit će potvrđen u emailu.",
    exploreOurBlog: "Istražite naš blog",
    redirectToShopInTenSeconds:
      "Bit ćete preusmjereni na trgovinu za 10 sekundi...",

    // Errors
    error: "Greška",
    somethingWentWrong: "Nešto je pošlo po krivu",
    tryAgain: "Pokušajte ponovno",
    invalidEmail: "Neispravan email",
    invalidPhone: "Neispravan broj telefona",
    invalidZipCode: "Neispravan poštanski broj",

    // Common
    all: "Sve",
    order: "Narudžba",
    method: "Metoda",
    categoryLabel: "Kategorija:",
    stockLabel: "Stanje:",
    statusLabel: "Status:",
    uploadImage: "Učitaj sliku",
    orImageUrl: "Ili URL slike",
    removeImage: "Ukloni sliku",
    addAnotherImage: "Dodaj još jednu sliku",
    languageLabels: "Oznake jezika",
    croatianLabel: "Hrvatski",
    englishLabel: "Engleski",
    categories: "Kategorije",
    allRightsReserved: "Sva prava pridržana.",
    quickLinks: "Brze poveznice",
    footerDescription:
      "Otkrijte fascinantni svijet povijesti kroz zadivljujuće priče, drevne artefakte i izvanredna otkrića koja su oblikovala naš svijet.",
    contactInfo: "Kontakt informacije",
    noData: "Nema podataka",
    search: "Pretraži",
    searchProducts: "Pretraži proizvode...",
    searchOrders: "Pretraži narudžbe...",
    filter: "Filtriraj",
    sort: "Sortiraj",
    sortBy: "Sortiraj po",
    defaultSort: "Zadano",
    priceLowToHigh: "Cijena: Od najniže",
    priceHighToLow: "Cijena: Od najviše",
    nameAscending: "Naziv: A-Ž",
    nameDescending: "Naziv: Ž-A",
    newest: "Najnovije",
    oldest: "Najstarije",
    showMore: "Prikaži više",
    more: "više",
    searchResults: "Rezultati pretrage za",
    results: "rezultata",
    quantity: "Količina",
    confirm: "Potvrdi",
    yes: "Da",
    no: "Ne",
    close: "Zatvori",
    menu: "Izbornik",
    openMenu: "Otvori izbornik",
    closeMenu: "Zatvori izbornik",
    back: "Natrag",
    next: "Sljedeće",
    previous: "Prethodno",
    ascending: "Uzlazno",
    descending: "Silazno",
    submit: "Pošalji",
    reset: "Resetiraj",
    clear: "Očisti",
    select: "Odaberi",
    choose: "Odaberi",
    upload: "Učitaj",
    download: "Preuzmi",
    print: "Ispiši",
    like: "Sviđa mi se",
    unlike: "Ne sviđa mi se",
    comment: "Komentar",
    reply: "Odgovori",
    follow: "Prati",
    unfollow: "Ne prati",
    subscribe: "Pretplati se",
    unsubscribe: "Odjavi se",
    signUp: "Registriraj se",
    signIn: "Prijavi se",
    adminLoginTitle: "Prijava u admin panel",
    adminLoginSubtitle: "Prijavite se svojim administratorskim podacima.",
    adminUsername: "Korisničko ime",
    adminPassword: "Lozinka",
    adminUsernamePlaceholder: "Admin korisničko ime",
    adminPasswordPlaceholder: "Admin lozinka",
    adminSigningIn: "Prijava...",
    adminSessionExpiredSignInAgain:
      "Sesija je istekla, prijavite se ponovno.",
    invalidServerResponse: "Neispravan odgovor servera.",
    invalidUsernameOrPassword: "Neispravno korisničko ime ili lozinka.",
    tooManyLoginAttempts: "Previše pokušaja prijave, pokušajte kasnije.",
    loginFailedTryAgain: "Prijava nije uspjela. Pokušajte ponovno.",
    forgotPassword: "Zaboravili ste lozinku?",
    resetPassword: "Resetiraj lozinku",
    changePassword: "Promijeni lozinku",
    profile: "Profil",
    showingRangeOfTotal: "Prikazano {start}-{end} od {total}",
    settings: "Postavke",
    notifications: "Obavijesti",
    help: "Pomoć",
    about: "O nama",
    terms: "Uvjeti",
    privacy: "Privatnost",
    cookies: "Kolačići",
    cookieSettings: "Postavke kolačića",
    cookieBannerTitle: "Privola za kolačiće",
    cookieBannerDescription:
      "Koristimo nužne kolačiće za rad stranice te opcionalne analitičke kolačiće (Google Analytics/Tag Manager) samo uz vašu privolu.",
    acceptAllCookies: "Prihvati sve",
    rejectNonEssential: "Odbij analitiku",
    sitemap: "Mapa stranice",
    accessibility: "Pristupačnost",
    support: "Podrška",
    feedback: "Povratne informacije",
    report: "Prijavi",
    flag: "Označi",
    block: "Blokiraj",
    unblock: "Odblokiraj",
    mute: "Utišaj",
    unmute: "Uključi zvuk",
    archive: "Arhiviraj",
    unarchive: "Dearchiviraj",
    pin: "Prikvači",
    unpin: "Otkvači",
    bookmark: "Oznaci kao favorit",
    unbookmark: "Ukloni iz favorita",
    favorite: "Favorit",
    unfavorite: "Ukloni iz favorita",
    star: "Označi zvjezdicom",
    unstar: "Ukloni zvjezdicu",
    upvote: "Glasaj za",
    downvote: "Glasaj protiv",

    // Admin Dashboard
    dashboardOverview: "Pregled nadzorne ploče",
    welcomeBack:
      "Dobrodošli natrag! Evo što se događa s vašom trgovinom danas.",
    totalProducts: "Ukupno proizvoda",
    blogPosts: "Blog postovi",
    lowStockItems: "Artikli s niskim zalihama",
    activePromotions: "Aktivne promocije",
    recentOrders: "Nedavne narudžbe",
    quickActions: "Brze radnje",
    viewAll: "Prikaži sve",
    noOrdersYet: "Još nema narudžbi",
    lowStockAlert: "Upozorenje o niskim zalihama",
    needsRestocking: "proizvod(a) treba dopuniti",
    viewProducts: "Prikaži proizvode",

    // Admin Actions
    addNewProduct: "Dodaj novi proizvod",
    addNewBlog: "Dodaj novi blog",
    addDiscountCode: "Dodaj kod popusta",
    viewOrders: "Prikaži narudžbe",
    manageOrders: "Upravljaj narudžbama",
    createPromotion: "Kreiraj promociju",
    writeNewArticle: "Napiši novi članak",
    createNewProduct: "Kreiraj novi proizvod",

    // Table Headers
    image: "Slika",
    name: "Naziv",
    category: "Kategorija",
    price: "Cijena",
    stock: "Zaliha",
    actions: "Akcije",
    orderNumber: "Broj narudžbe",
    customer: "Kupac",
    status: "Status",
    payment: "Plaćanje",
    date: "Datum",
    items: "Artikli",
    title: "Naslov",
    publishedDate: "Datum objave",
    code: "Kod",
    description: "Opis",
    type: "Tip",
    value: "Vrijednost",

    // Actions
    edit: "Uredi",
    delete: "Obriši",
    view: "Prikaži",
    create: "Kreiraj",
    update: "Ažuriraj",

    // Product Management
    productManagement: "Upravljanje proizvodima",
    manageYourCatalog: "Upravljajte katalogom proizvoda",
    activeProducts: "Aktivni proizvodi u katalogu",
    needRestocking: "Proizvodi trebaju dopunu",
    activeProductsInCatalog: "Aktivni proizvodi u katalogu",
    productsNeedRestocking: "Proizvodi trebaju dopunu",
    noProductsFound: "Nema pronađenih proizvoda",
    addYourFirstProduct: "Dodajte svoj prvi proizvod!",
    searchProductsByName: "Pretraži proizvode po nazivu...",
    allCategories: "Sve kategorije",

    // Blog Management
    blogManagement: "Upravljanje blogom",
    createAndManagePosts: "Kreirajte i upravljajte postovima na blogu",
    publishedBlogPosts: "Objavljeni blog postovi",
    noBlogsFound: "Nema pronađenih blogova",
    createFirstBlogPost: "Kreirajte svoj prvi blog post!",
    searchBlogsByTitle: "Pretraži blogove po naslovu...",

    // Discount Codes
    discountCodesManagement: "Upravljanje kodovima popusta",
    createAndManageDiscounts: "Kreirajte i upravljajte kodovima popusta",
    totalDiscountCodes: "ukupno kodova popusta",
    noDiscountCodesFound: "Nema pronađenih kodova popusta",
    createFirstPromotion: "Kreirajte svoju prvu promociju!",
    searchDiscountCodes: "Pretraži kodove popusta...",
    discountType: "Tip popusta",
    discountValue: "Vrijednost popusta",
    minimumOrderValue: "Minimalna vrijednost narudžbe",
    maxDiscountAmount: "Maksimalna vrijednost popusta",
    validFrom: "Vrijedi od",
    validUntil: "Vrijedi do",
    maxUses: "Maksimalno korištenja",
    active: "Aktivan",
    inactive: "Neaktivan",
    percentage: "Postotak",
    fixedAmount: "Fiksni iznos",
    optional: "opcionalno",
    leaveEmptyForNoLimit: "Ostavite prazno za neograničeno",
    leaveEmptyForNoExpiration: "Ostavite prazno za bez isteka",
    unlimited: "Neograničeno",
    codeCannotBeChanged: "Kod se ne može promijeniti nakon kreiranja",

    // Orders Management
    ordersManagement: "Upravljanje narudžbama",
    manageCustomerOrders: "Upravljajte narudžbama kupaca",
    totalOrders: "ukupno narudžbi",
    noOrdersFound: "Nema pronađenih narudžbi",
    searchByOrderNameEmail: "Pretraži po broju narudžbe, imenu, emailu...",
    orderDetails: "Detalji narudžbe",
    customerInformation: "Informacije o kupcu",
    orderItems: "Artikli narudžbe",
    orderTotals: "Ukupno narudžbe",
    orderStatus: "Status narudžbe",
    paymentMethod: "Način plaćanja",
    paymentStatus: "Status plaćanja",
    notes: "Napomene",

    // Order Status
    pending: "Na čekanju",
    confirmed: "Potvrđeno",
    processing: "U obradi",
    shipped: "Poslano",
    delivered: "Dostavljeno",
    cancelled: "Otkazano",
    completed: "Završeno",

    // Form Labels
    required: "obavezno",
    titleCroatian: "Naslov (Hrvatski)",
    titleEnglish: "Naslov (Engleski)",
    contentCroatian: "Sadržaj (Hrvatski)",
    contentEnglish: "Sadržaj (Engleski)",
    excerptCroatian: "Izvadak (Hrvatski)",
    excerptEnglish: "Izvadak (Engleski)",
    nameCroatian: "Naziv (Hrvatski)",
    nameEnglish: "Naziv (Engleski)",
    descriptionCroatian: "Opis (Hrvatski)",
    descriptionEnglish: "Opis (Engleski)",
    imageUrl: "URL slike",
    productImages: "Slike proizvoda",
    blogImages: "Slike bloga",
    maxImages: "Maksimalno 5 slika",
    manufacturer: "Proizvođač",
    summerSaleDiscount: "Ljetni popust",

    // Messages
    loadingDashboard: "Učitavanje nadzorne ploče...",
    loadingProducts: "Učitavanje proizvoda...",
    loadingBlogs: "Učitavanje blogova...",
    loadingDiscountCodes: "Učitavanje kodova popusta...",
    loadingOrders: "Učitavanje narudžbi...",
    saving: "Spremanje...",
    creating: "Kreiranje...",
    updating: "Ažuriranje...",
    deleting: "Brisanje...",

    // Success/Error Messages
    productCreatedSuccessfully: "Proizvod uspješno kreiran!",
    productUpdatedSuccessfully: "Proizvod uspješno ažuriran!",
    productDeletedSuccessfully: "Proizvod uspješno obrisan!",
    blogCreatedSuccessfully: "Blog uspješno kreiran!",
    blogUpdatedSuccessfully: "Blog uspješno ažuriran!",
    blogDeletedSuccessfully: "Blog uspješno obrisan!",
    discountCodeCreatedSuccessfully: "Kod popusta uspješno kreiran!",
    discountCodeUpdatedSuccessfully: "Kod popusta uspješno ažuriran!",
    discountCodeDeletedSuccessfully: "Kod popusta uspješno obrisan!",
    orderStatusUpdated: "Status narudžbe ažuriran",
    failedToSave: "Spremanje nije uspjelo",
    failedToDelete: "Brisanje nije uspjelo",
    areYouSureDelete: "Jeste li sigurni da želite obrisati",
    unknownDate: "Nepoznat datum",
    productOnSale: "Proizvod je na akciji",
    addBrush: "Dodaj kist",
    noThanks: "Ne treba",
    brushRecommendationPrompt:
      "Uz boju preporučujemo i kist. Želiš ga odmah dodati?",
    onSaleRightNow: "Proizvodi na akciji",
    noActivePromotions: "Trenutno nema aktivnih akcija.",
    sale: "Akcija",
    clearSearch: "Obriši pretragu",
    filters: "Filteri",
    clearFilters: "Reset filtera",
    categoriesLabel: "Kategorije",
    selectCategory: "Odaberi kategoriju...",
    clearCategory: "Očisti kategoriju",
    tags: "Tagovi",
    selectTags: "Odaberi tagove...",
    clearTags: "Očisti tagove",
    onSale: "Akcija",
    showOnlyDiscountedProducts: "Prikaži samo proizvode na akciji",
    discountNotAppliedToSaleItems:
      "Kodovi za popust vrijede samo za proizvode koji nisu na akciji.",
    validationRequiredField: "Ovo polje je obavezno.",
    validationMinTwoChars: "Unesite barem 2 znaka.",
    validationZipRequired: "Poštanski broj je obavezan.",
    validationZipNumbersOnly:
      "Poštanski broj mora sadržavati samo brojeve (3-10).",
    validationEmailRequired: "Email je obavezan.",
    validationEmailInvalid: "Unesite ispravan email.",
    validationPhoneRequired: "Telefon je obavezan.",
    validationPhoneFormat: "Format telefona: +385123456789 ili 00385123456789.",
    validationCountryRequired: "Odaberite državu.",
    codOnlyCroatia: "Pouzeće je dostupno samo za Hrvatsku.",
    changeCountryToCroatiaForCod: "Promijeni državu na Hrvatsku za pouzeće",
    codAvailableOnlyCroatia: "Dostupno samo za Hrvatsku",
    selectCountryAtCheckout:
      "Cijena dostave će se prikazati nakon odabira države.",
    salePriceMustBeLowerThanRegular:
      "Akcijska cijena mora biti niža od redovne cijene.",
    salePriceEur: "Akcijska cijena (EUR)",
    leaveEmptyForNoSale: "Prazno = bez akcije",
    filterTags: "Filter tagovi",
    noTagsDefined: "Nema definiranih tagova.",
    modelAccessoriesNotice:
      "Proizvodi iz kategorije Makete ne sadrže pribor. ",
    viewAccessories: "Pogledaj dodatke →",
    priceEur: "Cijena (€)",
  },

  en: {
    // Header
    home: "Home",
    shop: "Shop",
    blog: "Blog",
    contact: "Contact",
    admin: "Admin",
    login: "Login",
    logout: "Logout",
    language: "Language",
    croatian: "Croatian",
    english: "English",

    // Hero Sections
    heroTitle:
      "Journey Through Time – From the Dawn of Civilization to Today's World",
    heroDescription:
      "Explore epic battles, legendary castles, ancient empires, and modern history – all in one",
    exploreHistory: "Explore History",
    blogHeroTitle: "Historical Chronicles",
    blogHeroSubtitle:
      "Explore the past through captivating stories and insights",
    shopHeroTitle: "Shop premium historical replicas and models",
    shopHeroSubtitle:
      "Fast delivery, secure checkout, and carefully selected products for collectors, hobbyists, and history enthusiasts.",
    webshopHeroBadge: "Historical Webshop",
    webshopHeroTitle: "Find the replica you will be proud to display",
    webshopHeroSubtitle:
      "Compare best-selling items, check prices quickly, and place your order in just a few clicks.",
    shopNow: "Shop Best Sellers",
    browseStories: "Need help choosing?",
    shopByCollection: "Shop by Collection",
    heroFastProcessing: "Orders processed within 24h",
    heroCashOnDeliveryCroatia: "Shipping across Croatia and worldwide",
    heroSecureCardCheckout: "Secure Stripe checkout",
    trustSupportEmail: "Support via email",

    // Home Page
    latestStories: "Latest Stories",
    latestFromWebshop: "Best sellers and latest arrivals",
    officialDealerships: "Official Dealerships",
    exploreCategories: "Explore Historical Categories",
    viewAllProducts: "View the full catalog",
    viewAllStories: "View All Stories",
    continueShopping: "Continue shopping",
    addToCart: "Add to cart now",
    viewDetails: "View product details",
    readMore: "Read More",

    // Categories
    artifacts: "Artifacts",
    books: "Books",
    replicas: "Replicas",
    collectibles: "Collectibles",
    warMachines: "War Machines",
    castles: "Castles",
    myths: "Myths",
    battles: "Battles",
    onTodaysDay: "On Today's Day",
    stories: "stories",
    history: "History",
    education: "Education",
    replicasLabel: "Replicas",
    models: "Models",
    modelAccessories: "Model Accessories",
    historicalCoins: "Historical Coins",
    weapons: "Weapons",
    militaryEquipment: "Military Equipment",
    collections: "Collections",
    colorDefault: "Default",
    colorOlive: "Olive",
    colorSand: "Sand",
    colorBlack: "Black",
    colorWhite: "White",
    colorGray: "Gray",
    colorRed: "Red",
    colorBlue: "Blue",
    colorGreen: "Green",
    colorBrown: "Brown",
    modelAccessoriesNotification:
      "Accessories for assembly and finishing are not included in model products. Go to Model Accessories to find accessories.",

    // Shop
    shoppingCart: "Shopping Cart",
    products: "Products",
    orderSummary: "Order Summary",
    subtotal: "Subtotal",
    shipping: "Shipping",
    total: "Total",
    freeShipping: "FREE SHIPPING",
    addMoreForFreeShipping: "Add €{amount} more for FREE shipping!",
    proceedToPayment: "Continue to secure checkout",
    backToShop: "Back to Shop",
    yourCartIsEmpty: "Your Cart is Empty",
    addProductsBeforeCheckout:
      "Add products to your cart and finish your order in under 2 minutes.",
    goToWebshopButton: "Browse products",
    checkout: "Checkout",
    enterStreetAddress: "Enter your street address",
    enterHouseApartmentNumber: "House/Apartment number",
    zipCodeExample: "e.g., 21000 (numbers only)",
    emailExample: "e.g., your.email@example.com",
    phoneNumberExample: "e.g., +385123456789 (must start with +)",

    // Product Detail Page
    noImageAvailable: "No Image Available",
    added: "Added",
    available: "Available",
    outOfStock: "Out of Stock",
    howToPurchase: "How to Purchase",
    toBuyThisProduct: "To buy this product:",
    goToWebshop: "Go to our",
    webshop: "Webshop",
    page: "page",
    findProductAndClick: 'Find this product and click "Add to Cart"',
    continueShoppingOrCheckout:
      "Keep browsing or continue to secure checkout",
    fillDetailsAndComplete:
      "Enter shipping details and complete your purchase with confidence",
    addToWishlist: "Add to Wishlist",
    share: "Share",
    relatedProducts: "Related Products",
    moreHistoricalItems: "More Historical Items",
    discoverMoreArtifacts: "Discover more fascinating historical artifacts...",
    viewMore: "View More",
    backToAllProducts: "Back to All Products",

    // Checkout
    shippingInformation: "Shipping Information",
    firstName: "First Name",
    lastName: "Last Name",
    address: "Address",
    houseNumber: "House Number",
    city: "City",
    zipCode: "ZIP Code",
    country: "Country",
    email: "Email",
    instagram: "Instagram",
    phone: "Phone",
    phoneNumber: "Phone Number",
    enterFirstName: "Enter your first name",
    enterLastName: "Enter your last name",
    enterAddress: "Enter your address",
    enterHouseNumber: "House/Apartment number",
    enterZipCode: "e.g., 21000 (numbers only)",
    enterCountry: "Enter your country",
    enterEmail: "e.g., your.email@example.com",
    enterPhone: "e.g., +385123456789 (must start with +)",
    phoneMustStartWithPlus:
      "Phone number must start with + (e.g., +385123456789)",
    phoneTooShort: "Phone number is too short",
    zipCodeNumbersOnly: "ZIP code must contain only numbers",

    // Admin
    addProduct: "Add Product",
    adminPanel: "Admin Panel",
    adminPanelSubtitle: "Manage your historical content and products",
    adminDashboard: "Dashboard",
    adminBlogs: "Blogs",
    adminProducts: "Products",
    adminDiscountCodes: "Discount Codes",
    adminOrders: "Orders",
    adminCategories: "Categories",
    adminProductTags: "Product Tags",
    adminShippingRates: "Shipping",
    adminDealerships: "Dealerships",
    welcomeAdmin: "Welcome",
    addBlog: "Add Blog",
    editBlog: "Edit Blog",
    blogTitle: "Blog Title",
    blogContent: "Blog Content",
    blogExcerpt: "Blog Excerpt",
    blogCategory: "Blog Category",
    blogImage: "Blog Image",
    editProduct: "Edit Product",
    productName: "Product Name",
    productDescription: "Product Description",
    productPrice: "Product Price",
    productCategory: "Product Category",
    productStock: "Stock",
    blogImages: "Blog Images",
    save: "Save",
    cancel: "Cancel",
    loading: "Loading...",
    noDescription: "No description available",

    // Blog
    latestBlogs: "Latest Blogs",
    blogNotFound: "Blog Not Found",
    blogNotFoundMessage: "The blog you're looking for doesn't exist.",
    backToBlog: "Back to Blog",
    backToAllBlogs: "Back to All Blogs",
    relatedArticles: "Related Articles",
    moreHistoricalStories: "More Historical Stories",
    discoverMoreTales: "Discover more fascinating tales from history...",
    author: "Author",
    published: "Published",
    unpublished: "Unpublished",

    // Contact
    contactUs: "Contact Us",
    sendMessage: "Send Message",
    yourName: "Your name",
    yourEmail: "Your email",
    message: "Message",
    send: "Send",
    getInTouch: "Talk to us before you buy",
    haveQuestions:
      "Need product guidance or help with your order? We reply quickly.",
    contactInformation: "Contact Information",
    businessAddress: "Business Address",
    businessDetails: "Business Details",
    djelatnost:
      "Djelatnost: 47920, Uslužne djelatnosti posredovanja u specijaliziranoj trgovini na malo",
    oib: "OIB: MB-99075784",
    yearOfEstablishment: "Godina osnivanja: 2025",
    businessDocuments: "Business Documents",
    termsOfBusiness: "Terms of Business",
    privacyPolicy: "Privacy Policy",
    rightToTerminate: "Right to Terminate",
    legalTermsTitle: "Terms of Business",
    legalTermsSubtitle: "General terms and conditions of the HISTORIO webshop",
    legalTermsTrade: "Sole proprietorship for trade intermediation",
    legalTermsOwner: "Owner: Mirko Vuletic",
    legalTermsAddress: "Address: Mosecka 107, 21000 Split, Croatia",
    legalTermsOib: "OIB: 99075784",
    legalTermsContactLabel: "Contact:",
    legalTermsPhone: "+385976991203",
    legalTermsGeneralTitle: "General provisions",
    legalTermsGeneralBody:
      "These Terms of Business regulate the use of the HISTORIO webshop available at historio.hr. A user is any person who accesses the website and places an order. A sales contract is considered concluded when the customer places an order through the website and the seller confirms that order.",
    legalTermsPricingTitle: "Prices and payment",
    legalTermsPricingBody:
      "All prices are displayed in euros (EUR). The merchant is not in the VAT system pursuant to Article 90, Paragraph 2 of the Croatian VAT Act. Payments are processed via Stripe card payments.",
    legalTermsShippingTitle: "Shipping",
    legalTermsShippingBody:
      "Products are delivered in Croatia and internationally via contracted courier services. Estimated delivery is 3-7 business days within Croatia, depending on product availability.",
    legalTermsWithdrawalTitle: "Right of withdrawal",
    legalTermsWithdrawalBody:
      "The customer has the right to withdraw from the contract within 14 days from receiving the goods, without giving any reason. More details are available on the Right of Withdrawal page.",
    legalTermsComplaintsTitle: "Complaints and returns",
    legalTermsComplaintsBody:
      "If a customer receives a damaged product or a product that does not match the order, the customer must notify the seller within 14 days. The seller is obliged to replace the product or issue a refund within a reasonable period.",
    legalTermsDisputesTitle: "Dispute resolution",
    legalTermsDisputesBody:
      "Disputes between the customer and the seller can be resolved out of court via the European Commission online dispute resolution platform. For all disputes, the competent court in Split has jurisdiction.",
    legalPrivacyTitle: "Privacy Policy",
    legalPrivacyIntro:
      "HISTORIO respects the privacy of its users and is committed to protecting personal data.",
    legalPrivacyCollectedTitle: "What data do we collect?",
    legalPrivacyCollected1: "Full name",
    legalPrivacyCollected2: "Shipping address",
    legalPrivacyCollected3: "Email address and phone number",
    legalPrivacyCollected4:
      "Payment data (processed via Stripe; the merchant does not see full card details)",
    legalPrivacyPurposeTitle: "Purpose of data processing",
    legalPrivacyPurposeIntro: "Data is used exclusively for:",
    legalPrivacyPurpose1: "processing orders and delivering products",
    legalPrivacyPurpose2: "communication with customers",
    legalPrivacyPurpose3:
      "fulfilling legal obligations (invoices and accounting)",
    legalPrivacyGdprTitle: "GDPR and legal basis for processing",
    legalPrivacyGdprBody:
      "We process personal data in accordance with the General Data Protection Regulation (GDPR). The legal basis for processing may include contract performance, compliance with legal obligations, legitimate interest, or user consent, depending on the purpose.",
    legalPrivacyControllerTitle: "Data controller",
    legalPrivacyControllerBody:
      "The data controller responsible for personal data processing is HISTORIO. For all privacy-related questions, contact us at:",
    legalPrivacyRetentionTitle: "Data retention period",
    legalPrivacyRetentionBody:
      "We retain data only as long as necessary to fulfill the processing purpose and legal obligations, after which it is deleted or anonymized.",
    legalPrivacyRightsTitle: "User rights",
    legalPrivacyRightsBody:
      "Users have the right to access, rectify, erase, and restrict processing of their personal data in accordance with GDPR. Requests can be submitted to:",
    legalPrivacyCookiesTitle: "Cookies",
    legalPrivacyCookiesBody:
      "The website uses cookies to improve user experience and analytics. Users can reject cookies in their browser settings.",
    legalPrivacySharingTitle: "Data sharing",
    legalPrivacySharingBody:
      "Data is shared only with necessary partners: delivery service providers and Stripe for payment processing.",
    legalWithdrawalTitle: "Right of Withdrawal",
    legalWithdrawalP1:
      "The customer may withdraw from a distance contract within 14 days from the date of receiving the product, without stating any reason.",
    legalWithdrawalP2:
      "To exercise the right of withdrawal, the customer must send a withdrawal notice to:",
    legalWithdrawalP3:
      "The customer bears the direct cost of returning the goods. The goods must be returned in proper and unused condition.",
    legalWithdrawalP4:
      "The seller must refund the paid amount within 14 days of receiving the withdrawal notice, or after the returned goods have been received.",
    legalWithdrawalFormTitle: "Withdrawal Form (PDF)",
    legalWithdrawalFormText:
      "The withdrawal form is available as a PDF document:",
    legalWithdrawalFormCta: "Download form (PDF)",
    sendUsMessage: "Send a message to our team",
    subject: "Subject",
    whatIsThisAbout: "How can we help?",
    tellUsMore: "Tell us what you are looking for and we will recommend the right product.",
    sendMessageButton: "Send inquiry",
    afterSubmittingNotePrefix:
      "* Your message will be sent directly to our team via this contact form. For urgent inquiries, you can also reach us at",
    afterSubmittingNoteSuffix: ".",
    frequentlyAskedQuestions: "Frequently Asked Questions",
    howToPurchaseCollectibles: "How can I purchase collectibles on Historio?",
    howToPurchaseAnswer:
      "Choose a product, add it to your cart, and complete checkout in a few secure steps.",
    canIContributeArticles: "Can I contribute articles to the Historio blog?",
    canIContributeAnswer:
      "Yes, we welcome guest writers! Reach out via our contact form for submission details.",
    areReplicasHandmade: "Are the replicas on Historio handmade?",
    areReplicasHandmadeAnswer:
      "Yes, many of our items are handcrafted by skilled artisans.",
    doesHistorioShipInternationally: "Does Historio ship internationally?",
    doesHistorioShipInternationallyAnswer:
      "Yes. We ship within Croatia and internationally, and you can review shipping costs before order confirmation.",
    canIPayWithCashOnDelivery: "Can I pay with cash on delivery?",
    canIPayWithCashOnDeliveryAnswerPrefix:
      "Yes! If you would like to pay with cash on delivery, please contact us through the contact form or email",
    canIPayWithCashOnDeliveryAnswerSuffix:
      "with your order details. Payment is made in cash at delivery and is available for orders within Croatia.",

    // Payment Methods
    creditCard: "Credit/Debit Card",
    creditDebitCard: "Credit/Debit Card (Stripe)",
    cashOnDelivery: "Cash on Delivery",
    availableWorldwide: "Available worldwide",
    placeOrderCashOnDelivery: "Place Order (Cash on Delivery)",
    placeOrder: "Confirm order",

    // Discount Code
    discountCode: "Discount Code",
    enterCode: "Enter code",
    apply: "Apply",
    discount: "Discount",
    discountApplied: "Discount applied",
    enterDiscountCode: "Please enter a discount code",
    invalidDiscountCode: "Invalid discount code",

    // Cart
    cartIsEmpty: "Your cart is empty",
    addItemsToCart: "Add items to your cart to checkout",
    free: "Free",

    // Errors
    checkoutError: "An error occurred. Please try again.",

    // Product Detail Page Additional
    productNotFound: "Product Not Found",
    productNotFoundMessage: "The product you're looking for doesn't exist.",

    // Contact Page Additional
    thankYouForMessage:
      "Thank you for your message! We have received your inquiry and will get back to you soon.",
    errorTryAgain:
      "There was an error. Please try again or email us directly at historio.info@gmail.com",
    sending: "Sending...",

    // Success
    orderSuccessful: "Order Successful!",
    thankYouForOrder: "Thank you for your order!",
    confirmationEmail: "Confirmation will be sent to your email.",
    orderPlacedSuccessfully: "Order Placed Successfully!",
    paymentSuccessful: "Payment Successful!",
    thankYouOrderConfirmedProcessedSoon:
      "Thank you for your order. Your order has been confirmed and will be processed shortly.",
    thankYouPurchaseConfirmed:
      "Thank you for your purchase. Your order has been confirmed.",
    whatHappensNext: "What happens next?",
    youWillReceiveEmailConfirmationShortly:
      "You will receive an email confirmation shortly",
    orderProcessedWithinBusinessDays:
      "Your order will be processed within 1-2 business days",
    cashOnDeliveryPaymentInfo:
      "You will pay in cash when the package is delivered to your address",
    youWillReceiveTrackingInfoWhenShipped:
      "You will receive tracking information once shipped",
    cashOnDeliveryInformation: "Cash on Delivery Information",
    cashOnDeliveryExactAmountNote:
      "Please have the exact amount ready when our delivery person arrives. The total amount will be confirmed in your email.",
    exploreOurBlog: "Explore Our Blog",
    redirectToShopInTenSeconds:
      "You will be redirected to the shop in 10 seconds...",

    // Errors
    error: "Error",
    somethingWentWrong: "Something went wrong",
    tryAgain: "Try again",
    invalidEmail: "Invalid email",
    invalidPhone: "Invalid phone number",
    invalidZipCode: "Invalid ZIP code",

    // Common
    all: "All",
    order: "Order",
    method: "Method",
    categoryLabel: "Category:",
    stockLabel: "Stock:",
    statusLabel: "Status:",
    uploadImage: "Upload Image",
    orImageUrl: "Or Image URL",
    removeImage: "Remove Image",
    addAnotherImage: "Add Another Image",
    languageLabels: "Language Labels",
    croatianLabel: "Croatian",
    englishLabel: "English",
    categories: "Categories",
    allRightsReserved: "All rights reserved.",
    quickLinks: "Quick Links",
    footerDescription:
      "Discover the fascinating world of history through captivating stories, ancient artifacts, and remarkable discoveries that shaped our world.",
    contactInfo: "Contact Info",
    noData: "No data",
    search: "Search",
    searchProducts: "Search products...",
    searchOrders: "Search orders...",
    filter: "Filter",
    sort: "Sort",
    sortBy: "Sort by",
    defaultSort: "Default",
    priceLowToHigh: "Price: Low to High",
    priceHighToLow: "Price: High to Low",
    nameAscending: "Name: A-Z",
    nameDescending: "Name: Z-A",
    newest: "Newest First",
    oldest: "Oldest First",
    showMore: "Show More",
    more: "more",
    searchResults: "Search results for",
    results: "results",
    quantity: "Quantity",
    confirm: "Confirm",
    yes: "Yes",
    no: "No",
    close: "Close",
    menu: "Menu",
    openMenu: "Open menu",
    closeMenu: "Close menu",
    back: "Back",
    next: "Next",
    previous: "Previous",
    ascending: "Ascending",
    descending: "Descending",
    submit: "Submit",
    reset: "Reset",
    clear: "Clear",
    select: "Select",
    choose: "Choose",
    upload: "Upload",
    download: "Download",
    print: "Print",
    like: "Like",
    unlike: "Unlike",
    comment: "Comment",
    reply: "Reply",
    follow: "Follow",
    unfollow: "Unfollow",
    subscribe: "Subscribe",
    unsubscribe: "Unsubscribe",
    signUp: "Sign Up",
    signIn: "Sign In",
    adminLoginTitle: "Admin Panel Login",
    adminLoginSubtitle: "Sign in with your administrator credentials.",
    adminUsername: "Username",
    adminPassword: "Password",
    adminUsernamePlaceholder: "Admin username",
    adminPasswordPlaceholder: "Admin password",
    adminSigningIn: "Signing in...",
    adminSessionExpiredSignInAgain: "Session expired, please sign in again.",
    invalidServerResponse: "Invalid response from server.",
    invalidUsernameOrPassword: "Invalid username or password.",
    tooManyLoginAttempts: "Too many login attempts, please try again later.",
    loginFailedTryAgain: "Login failed. Please try again.",
    forgotPassword: "Forgot Password?",
    resetPassword: "Reset Password",
    changePassword: "Change Password",
    profile: "Profile",
    showingRangeOfTotal: "Showing {start}-{end} of {total}",
    settings: "Settings",
    notifications: "Notifications",
    help: "Help",
    about: "About",
    terms: "Terms",
    privacy: "Privacy",
    cookies: "Cookies",
    cookieSettings: "Cookie settings",
    cookieBannerTitle: "Cookie consent",
    cookieBannerDescription:
      "We use essential cookies for site functionality and optional analytics cookies (Google Analytics/Tag Manager) only with your consent.",
    acceptAllCookies: "Accept all",
    rejectNonEssential: "Reject analytics",
    sitemap: "Sitemap",
    accessibility: "Accessibility",
    support: "Support",
    feedback: "Feedback",
    report: "Report",
    flag: "Flag",
    block: "Block",
    unblock: "Unblock",
    mute: "Mute",
    unmute: "Unmute",
    archive: "Archive",
    unarchive: "Unarchive",
    pin: "Pin",
    unpin: "Unpin",
    bookmark: "Bookmark",
    unbookmark: "Remove Bookmark",
    favorite: "Favorite",
    unfavorite: "Remove Favorite",
    star: "Star",
    unstar: "Remove Star",
    upvote: "Upvote",
    downvote: "Downvote",

    // Admin Dashboard
    dashboardOverview: "Dashboard Overview",
    welcomeBack: "Welcome back! Here's what's happening with your store today.",
    totalProducts: "Total Products",
    blogPosts: "Blog Posts",
    lowStockItems: "Low Stock Items",
    activePromotions: "Active Promotions",
    recentOrders: "Recent Orders",
    quickActions: "Quick Actions",
    viewAll: "View All",
    noOrdersYet: "No orders yet",
    lowStockAlert: "Low Stock Alert",
    needsRestocking: "product(s) need restocking",
    viewProducts: "View Products",

    // Admin Actions
    addNewProduct: "Add New Product",
    addNewBlog: "Add New Blog",
    addDiscountCode: "Add Discount Code",
    viewOrders: "View Orders",
    manageOrders: "Manage Orders",
    createPromotion: "Create Promotion",
    writeNewArticle: "Write New Article",
    createNewProduct: "Create New Product",

    // Table Headers
    image: "Image",
    name: "Name",
    category: "Category",
    price: "Price",
    stock: "Stock",
    actions: "Actions",
    orderNumber: "Order Number",
    customer: "Customer",
    status: "Status",
    payment: "Payment",
    date: "Date",
    items: "Items",
    title: "Title",
    publishedDate: "Published Date",
    code: "Code",
    description: "Description",
    type: "Type",
    value: "Value",

    // Actions
    edit: "Edit",
    delete: "Delete",
    view: "View",
    create: "Create",
    update: "Update",

    // Product Management
    productManagement: "Product Management",
    manageYourCatalog: "Manage your product catalog",
    activeProducts: "Active products",
    needRestocking: "Products need restocking",
    activeProductsInCatalog: "Active products in catalog",
    productsNeedRestocking: "Products need restocking",
    noProductsFound: "No products found",
    addYourFirstProduct: "Add your first product!",
    searchProductsByName: "Search products by name...",
    allCategories: "All Categories",

    // Blog Management
    blogManagement: "Blog Management",
    createAndManagePosts: "Create and manage blog posts",
    publishedBlogPosts: "Published blog posts",
    noBlogsFound: "No blogs found",
    createFirstBlogPost: "Create your first blog post!",
    searchBlogsByTitle: "Search blogs by title...",

    // Discount Codes
    discountCodesManagement: "Discount Codes Management",
    createAndManageDiscounts: "Create and manage discount codes",
    totalDiscountCodes: "total discount codes",
    noDiscountCodesFound: "No discount codes found",
    createFirstPromotion: "Create your first promotion!",
    searchDiscountCodes: "Search discount codes...",
    discountType: "Discount Type",
    discountValue: "Discount Value",
    minimumOrderValue: "Minimum Order Value",
    maxDiscountAmount: "Max Discount Amount",
    validFrom: "Valid From",
    validUntil: "Valid Until",
    maxUses: "Max Uses",
    active: "Active",
    inactive: "Inactive",
    percentage: "Percentage",
    fixedAmount: "Fixed Amount",
    optional: "optional",
    leaveEmptyForNoLimit: "Leave empty for no limit",
    leaveEmptyForNoExpiration: "Leave empty for no expiration",
    unlimited: "Unlimited",
    codeCannotBeChanged: "Code cannot be changed after creation",

    // Orders Management
    ordersManagement: "Orders Management",
    manageCustomerOrders: "Manage customer orders",
    totalOrders: "total orders",
    noOrdersFound: "No orders found",
    searchByOrderNameEmail: "Search by order #, name, email...",
    orderDetails: "Order Details",
    customerInformation: "Customer Information",
    orderItems: "Order Items",
    orderTotals: "Order Totals",
    orderStatus: "Order Status",
    paymentMethod: "Payment Method",
    paymentStatus: "Payment Status",
    notes: "Notes",

    // Order Status
    pending: "Pending",
    confirmed: "Confirmed",
    processing: "Processing",
    shipped: "Shipped",
    delivered: "Delivered",
    cancelled: "Cancelled",
    completed: "Completed",

    // Form Labels
    required: "required",
    titleCroatian: "Title (Croatian)",
    titleEnglish: "Title (English)",
    contentCroatian: "Content (Croatian)",
    contentEnglish: "Content (English)",
    excerptCroatian: "Excerpt (Croatian)",
    excerptEnglish: "Excerpt (English)",
    nameCroatian: "Name (Croatian)",
    nameEnglish: "Name (English)",
    descriptionCroatian: "Description (Croatian)",
    descriptionEnglish: "Description (English)",
    imageUrl: "Image URL",
    productImages: "Product Images",
    maxImages: "Max 5 images",
    manufacturer: "Manufacturer",
    summerSaleDiscount: "Summer sale discount",

    // Messages
    loadingDashboard: "Loading dashboard...",
    loadingProducts: "Loading products...",
    loadingBlogs: "Loading blogs...",
    loadingDiscountCodes: "Loading discount codes...",
    loadingOrders: "Loading orders...",
    saving: "Saving...",
    creating: "Creating...",
    updating: "Updating...",
    deleting: "Deleting...",

    // Success/Error Messages
    productCreatedSuccessfully: "Product created successfully!",
    productUpdatedSuccessfully: "Product updated successfully!",
    productDeletedSuccessfully: "Product deleted successfully!",
    blogCreatedSuccessfully: "Blog created successfully!",
    blogUpdatedSuccessfully: "Blog updated successfully!",
    blogDeletedSuccessfully: "Blog deleted successfully!",
    discountCodeCreatedSuccessfully: "Discount code created successfully!",
    discountCodeUpdatedSuccessfully: "Discount code updated successfully!",
    discountCodeDeletedSuccessfully: "Discount code deleted successfully!",
    orderStatusUpdated: "Order status updated",
    failedToSave: "Failed to save",
    failedToDelete: "Failed to delete",
    areYouSureDelete: "Are you sure you want to delete",
    unknownDate: "Unknown date",
    productOnSale: "This product is on sale",
    addBrush: "Add brush",
    noThanks: "No thanks",
    brushRecommendationPrompt:
      "We recommend adding a brush with this paint. Add it now?",
    onSaleRightNow: "On sale right now",
    noActivePromotions: "No active promotions at the moment.",
    sale: "Sale",
    clearSearch: "Clear search",
    filters: "Filters",
    clearFilters: "Clear filters",
    categoriesLabel: "Categories",
    selectCategory: "Select category...",
    clearCategory: "Clear category",
    tags: "Tags",
    selectTags: "Select tags...",
    clearTags: "Clear tags",
    onSale: "On sale",
    showOnlyDiscountedProducts: "Show only discounted products",
    discountNotAppliedToSaleItems:
      "Discount codes apply only to products that are not on sale.",
    validationRequiredField: "This field is required.",
    validationMinTwoChars: "Please enter at least 2 characters.",
    validationZipRequired: "ZIP code is required.",
    validationZipNumbersOnly: "ZIP code must contain only numbers (3-10).",
    validationEmailRequired: "Email is required.",
    validationEmailInvalid: "Please enter a valid email.",
    validationPhoneRequired: "Phone is required.",
    validationPhoneFormat: "Phone format: +385123456789 or 00385123456789.",
    validationCountryRequired: "Please select a country.",
    codOnlyCroatia: "Cash on delivery is available only for Croatia.",
    changeCountryToCroatiaForCod: "Change country to Croatia to use cash on delivery",
    codAvailableOnlyCroatia: "Available only for Croatia",
    selectCountryAtCheckout:
      "Shipping price will be shown after selecting a country.",
    salePriceMustBeLowerThanRegular:
      "Sale price must be lower than regular price.",
    salePriceEur: "Sale price (EUR)",
    leaveEmptyForNoSale: "Leave empty for no sale",
    filterTags: "Filter tags",
    noTagsDefined: "No tags defined.",
    modelAccessoriesNotice: "Model products do not include accessories. ",
    viewAccessories: "View accessories →",
    priceEur: "Price (€)",
  },
};

// Helper function to get translation
export const t = (key, language = 'hr', params = {}) => {
    const translation = translations[language]?.[key] || key;

    // Ensure translation is a string before calling replace
    if (typeof translation !== 'string') {
        return key;
    }

    // Replace parameters like {amount} with actual values
    return translation.replace(/\{(\w+)\}/g, (match, param) => {
        return params[param] || match;
    });
};
